import React, { Component } from 'react';
import SearchBar from 'components/shared/SearchBar/SearchBar';
import { setSingleDevicePageSearchBarIndex } from 'redux/actions';
import { isObjectEmpty } from 'common/utils/helpers';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { PerfectScrollbar } from 'components/shared/ReactPerfectScrollbar';

import './SingleDeviceSearchBar.css';

class SingleDeviceSearchBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchBarValue: '',
      filterText: '',
      mouseEnabled: true,
      animateError: 0
    };
  }

  componentDidUpdate() {
    const {
      props: { index },
      state: { mouseEnabled }
    } = this;

    if (index !== null && this.refs[index] !== null && mouseEnabled === false) {
      let bottom = this.refs[index].offsetTop + this.refs[index].offsetHeight;
      let top = this.refs[index].offsetTop;
      if (bottom > this.containerRef.clientHeight + this.containerRef.scrollTop) {
        this.containerRef.scrollTop += this.refs[index].offsetHeight;
      } else if (this.containerRef.scrollTop > top) {
        this.containerRef.scrollTop -= this.refs[index].offsetHeight;
      }

      bottom = this.refs[index].offsetTop + this.refs[index].offsetHeight;
      top = this.refs[index].offsetTop;
      /* if, after adjustment, element is still not in view, then user must've scrolled away.
               Set scroll position so highlighted element is at the top*/
      if (bottom > this.containerRef.clientHeight + this.containerRef.scrollTop || this.containerRef.scrollTop > top) {
        this.containerRef.scrollTop = top;
      }
    }
  }

  render() {
    const {
      props: { devicesIds, history, dispatch, match, defaultText },
      state: { searchBarValue }
    } = this;
    let dropdown = null;
    let filteredDevicesIds = [];

    if (!isObjectEmpty(devicesIds)) {
      if (searchBarValue !== '') {
        devicesIds.forEach((deviceId, index) => {
          if (deviceId.includes(searchBarValue)) {
            filteredDevicesIds.push(deviceId);
          }
        });

        filteredDevicesIds = filteredDevicesIds.slice(0, 50);
      } else {
        filteredDevicesIds = devicesIds.slice(0, 50);
      }

      this.refs = [];

      dropdown = (
        <div className="DeviceSearchBarDropdown_ContainerDiv" ref={(ref) => (this.containerRef = ref)}>
          <ul className="DeviceSearchBarDropdown_Ul">
            <PerfectScrollbar className="DeviceSearchBarDropdown_PS">
              <div className="DeviceSearchBarDropdown_Header">Devices</div>
              {filteredDevicesIds.map((deviceId, index) => {
                let strIndex = deviceId.indexOf(searchBarValue);
                let str1 = deviceId.substring(0, strIndex);
                let str2 = deviceId.substring(strIndex, strIndex + searchBarValue.length);
                let str3 = deviceId.substring(strIndex + searchBarValue.length);

                let className = 'DeviceSearchBarDropdown_Li';
                if (index === this.props.index) {
                  className += ' DeviceSearchBarDropdown_Li_Hovered';
                }

                return (
                  <li
                    className={className}
                    key={index}
                    ref={(ref) => (this.refs[index] = ref)}
                    onMouseDown={(event) => {
                      if (history.location.search.substring(1) !== deviceId) {
                        history.push('/console/devices/detail?' + deviceId);
                        this.setState({ searchBarValue: '' });
                        dispatch(setSingleDevicePageSearchBarIndex(null));
                      }
                    }}
                    onMouseOver={() => {
                      if (this.state.mouseEnabled) {
                        //dispatch(setSingleDevicePageSearchBarIndex(index));
                      }
                    }}
                  >
                    <div className="DeviceSearchBarDropdown_String">{str1}</div>
                    <div className="DeviceSearchBarDropdown_String_Highlighted">{str2}</div>
                    <div className="DeviceSearchBarDropdown_String">{str3}</div>
                  </li>
                );
              })}
              {filteredDevicesIds && filteredDevicesIds.length === 0 ? (
                <li className="DeviceSearchBarDropdown_Li">
                  <div className="DeviceSearchBarDropdown_String">No devices match search</div>
                </li>
              ) : null}
            </PerfectScrollbar>
          </ul>
        </div>
      );
    }

    return (
      <SearchBar
        iconClassName={'SingleDevicePage_SearchBar'}
        searchQuery={(value) => this.setState({ searchBarValue: value })}
        defaultText={'Look up other devices'}
        dropdown={dropdown}
        key={match.params.id} /* When key changes, component is destroyed and recreated, giving fresh state*/
        handleBlur={(target) => {
          dispatch(setSingleDevicePageSearchBarIndex(null));
        }}
        onInit={() => {
          dispatch(setSingleDevicePageSearchBarIndex(null));
        }}
        handleArrow={(key, searchBar) => {
          let index = this.props.index;

          if (key === 'ArrowUp') {
            if (index == null) {
              return;
            } else if (index > 0) {
              index -= 1;
            }
          } else if (key === 'ArrowDown') {
            if (index == null) {
              index = 0;
            } else if (index < filteredDevicesIds.length - 1) {
              index += 1;
            } else {
              index = filteredDevicesIds.length - 1;
            }
          }

          if (key === 'ArrowUp' || key === 'ArrowDown') {
            this.setState({ mouseEnabled: false });
            if (filteredDevicesIds && filteredDevicesIds.length > 0) {
              searchBar.setState({ value: filteredDevicesIds[index] });
              dispatch(setSingleDevicePageSearchBarIndex(index));
            }
          }
        }}
        handleEnter={(event, searchBar) => {
          let value = event.target.value;
          let found = false;
          filteredDevicesIds.forEach((deviceId) => {
            if (value === deviceId) {
              history.push('/console/devices/detail?' + deviceId);
              this.setState({ searchBarValue: '' });
              searchBar.setState({ focused: false, touched: false, value: defaultText ? defaultText : 'Search' });
              event.target.blur();
              searchBar.props.searchQuery('');
              found = true;
              return;
            }
          });
          /* No matching device name */
          if (!found) {
            if (!this.animateError) {
              this.animateError = true; //non state variable used because it updates immediately
              setTimeout(() => {
                this.animateError = false;
                searchBar.setState({ animateError: 0 });
              }, 300);
              searchBar.setState({ animateError: 1 }); //state variable used to force rerender
            }
          }
        }}
      />
    );
  }
}

export default withRouter(
  connect((store) => {
    return {
      index: store.ui.singleDevicePage.searchBarIndex,
      devicesIds: store.data.devicesIds
    };
  })(SingleDeviceSearchBar)
);
